import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentStep: 1,
  formData: {},
  formStructure: {},
};

const ViewformSlice = createSlice({
  name: "Viewform",
  initialState,
  reducers: {
    setStep: (state, action) => {
      state.currentStep = action.payload;
    },
    setFormStructure: (state, action) => {
      state.formStructure = action.payload || {};
    },
    setFormData: (state, action) => {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    setInitialFormData: (state, action) => {
      const initialData = action.payload;

      state.formData = initialData;
    },
    removeFormField: (state, action) => {
      const name = action.payload;
      delete state.formData[name];
    },
    resetFormData: (state) => {
      state.formData = {};
      state.formStructure = {};
      state.currentStep = 1;
    },
  },
});

export const {
  setFormStructure,
  setFormData,
  setStep,
  removeFormField,
  setInitialFormData,
  resetFormData,
} = ViewformSlice.actions;

export default ViewformSlice.reducer;
